export type FeatureToggleDetail = {
  key: string;
  name: string;
  categoryKey: string;
  categoryName: string;
  enabled: boolean;
  selectedValues: SelectedValue[];
  additionalFields?: AdditionalFields[];
};

export type FeatureToggleDetailExtended = FeatureToggleDetail & {
  selectedValues: SelectedValueExtended[];
};

export type FeatureToggleStatus = {
  key: string;
  categoryKey: string;
  enabled: boolean;
  additionalValues?: AdditionalFieldsValues[];
};

export type SelectedValue = {
  country: string | null;
  level: ToggleLevel;
  enabledFor: string[];
  disabledFor: string[];
  additionalValues?: AdditionalFieldsValues[];
};

export type SelectedValueExtended = SelectedValue & {
  isSaved: boolean;
};

export type AdditionalFields = {
  type: string;
  key: string;
  name: string;
  defaultValues?: string[];
  options: Option[];
};

export type Option = {
  key: string;
  label: string;
};

export type AdditionalFieldsValues = {
  key: string;
  values: string[];
};

export enum ToggleLevel {
  COUNTRY = "COUNTRY",
  ACCOUNT = "ACCOUNT",
  BRANCH = "BRANCH",
}

export type FeatureToggleMap = Map<string, FeatureToggleDetail[]>;

export type FeatureToggleMapExtended = Map<
  string,
  FeatureToggleDetailExtended[]
>;

export type FeatureToggleStatusMap = Map<string, FeatureToggleStatus[]>;

export type FeatureToggleMapForPage = Map<string, FeatureToggle[]>;

export type FeatureToggleCategory = {
  key: string;
  name: string;
  toggles: FeatureToggle[];
};

export type FeatureToggle = {
  key: string;
  name: string;
  enabled: boolean;
  usedCountries: Set<string>;
  configurations: Configuration[];
  additionalFields: AdditionalFields[];
};

export type Configuration = {
  id: number;
  level: ToggleLevel;
  countryKey?: string;
  idValues: string;
  areIdsExcluded: boolean;
  showIdTextField: boolean;
  showEmptyIdsError: boolean;
  selectedValuesForAdditionalFields: Map<string, string[]>;
};

export type UpdateTogglesResult = {
  updatedOriginalFeatureMap: FeatureToggleMapExtended;
  updatedFeatureMap: FeatureToggleMapExtended;
  errors: UpdateTogglesErrorMap;
};

export type UpdateTogglesErrorMap = Map<
  string,
  { toggleKey: string; error?: any }[]
>;

export type SideMenuCategories = Map<
  string,
  { category: string; selected: boolean }
>;
